import React from 'react';
import { Section } from './ui/Section';
export function Stats() {
  return <Section variant="alt" data-id="element-178">
      <div className="bg-white border-2 border-brand-primary rounded-lg p-6 shadow-card" data-id="element-179">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center" data-id="element-180">
          <div data-id="element-181">
            <div className="font-heading text-2xl md:text-3xl font-bold text-brand-accent" data-id="element-182">
              +8.000
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-183">
              Psicólogos activos
            </div>
          </div>
          <div data-id="element-184">
            <div className="font-heading text-2xl md:text-3xl font-bold text-brand-accent" data-id="element-185">
              600+
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-186">
              Consultas lanzadas
            </div>
          </div>
          <div data-id="element-187">
            <div className="font-heading text-2xl md:text-3xl font-bold text-brand-accent" data-id="element-188">
              200K+
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-189">
              Páginas material
            </div>
          </div>
          <div data-id="element-190">
            <div className="font-heading text-2xl md:text-3xl font-bold text-brand-accent" data-id="element-191">
              5h+
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-192">
              Ahorradas/semana
            </div>
          </div>
        </div>
      </div>
    </Section>;
}